import { render } from "./PagePortfolio.vue?vue&type=template&id=6832d8af"
import script from "./PagePortfolio.vue?vue&type=script&lang=js"
export * from "./PagePortfolio.vue?vue&type=script&lang=js"

import "./PagePortfolio.vue?vue&type=style&index=0&id=6832d8af&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__